export default __webpack_public_path__ + "static/media/george_l.38bfe549.jpg";